import {createHashHistory} from "history";

const History = createHashHistory();

export default History;
